/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DadosLinhaTempoAcordo } from '../models/dados-linha-tempo-acordo';
import { DadosErroSAP } from '../models/dados-erro-sap';
@Injectable({
  providedIn: 'root',
})
class HistoricoService extends __BaseService {
  static readonly obterLinhaTempoAcordoPath = '/linha-tempo/{codigoAcordo}';
  static readonly obterHistoricoErrosSAPPath = '/erros-sap/{codigoAcordo}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera os dados para a linha do tempo da proposta / acordo
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterLinhaTempoAcordoResponse(codigoAcordo: number): __Observable<__StrictHttpResponse<Array<DadosLinhaTempoAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/linha-tempo/${encodeURIComponent(String(codigoAcordo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DadosLinhaTempoAcordo>>;
      })
    );
  }
  /**
   * Recupera os dados para a linha do tempo da proposta / acordo
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterLinhaTempoAcordo(codigoAcordo: number): __Observable<Array<DadosLinhaTempoAcordo>> {
    return this.obterLinhaTempoAcordoResponse(codigoAcordo).pipe(
      __map(_r => _r.body as Array<DadosLinhaTempoAcordo>)
    );
  }

  /**
   * Recupera o historico de erros que aconteceram no SAP para um determinado acordo
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterHistoricoErrosSAPResponse(codigoAcordo: number): __Observable<__StrictHttpResponse<Array<DadosErroSAP>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/erros-sap/${encodeURIComponent(String(codigoAcordo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DadosErroSAP>>;
      })
    );
  }
  /**
   * Recupera o historico de erros que aconteceram no SAP para um determinado acordo
   * @param codigoAcordo Codigo identificador do acordo
   * @return Operacao realizada com sucesso
   */
  obterHistoricoErrosSAP(codigoAcordo: number): __Observable<Array<DadosErroSAP>> {
    return this.obterHistoricoErrosSAPResponse(codigoAcordo).pipe(
      __map(_r => _r.body as Array<DadosErroSAP>)
    );
  }
}

module HistoricoService {
}

export { HistoricoService }
